// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4303ce03","455":"da78f043"}[chunkId] + ".chunk.js";
};